import React, { useLayoutEffect, useState, useRef } from 'react';

import { Parallax } from 'rc-scroll-anim';

import Marquee from 'react-fast-marquee';
import { MarqueeProps } from './types';

import { throttle } from 'throttle-debounce';

import useInView from 'react-cool-inview';

import covidModel from '@assets/images/covid-model.webp';

let topPosLeft = 0;
let topPosRight = 0;
let topPosCoeff = 30;
let btmPosCoeff = 180;

type BlockScrollTextProps = {
  isDesktopOrLaptop?: any;
};

export const BlockScrollText: React.FC<BlockScrollTextProps> = ({ isDesktopOrLaptop }) => {
  /*
  const [scrollPosition, setPosition] = useState(0);
  const [fixScrollDirection, setFixDirection] = useState('down');
  const [fixScrollPosition, setFixPosition] = useState(0);
  const [winHeight, setWinHeight] = useState(0);

  // const textFrst = useRef<HTMLDivElement>(null);
  // const textSecond = useRef<HTMLDivElement>(null);
  const [scrollDir, setScrollDir] = useState('down');

  useLayoutEffect(() => {
    const threshold = 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;
  
    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;
  
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY ? 'down' : 'up');
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const updatePosition = () => {
      setPosition(window.pageYOffset);
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    }

    window.addEventListener('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  const {
    observe,
  } = useInView<HTMLDivElement>({
    threshold: 0.50, // Default is 0
    onChange: ({ observe, unobserve }) => {
      // Triggered whenever the target meets a threshold, e.g. [0.25, 0.5, ...]
      unobserve(); // To stop observing the current target element
      observe(); // To re-start observing the current target element
    },
    onEnter: ({ entry }) => {
      // Triggered when the target enters the viewport
      const { rootBounds } = entry;
      const { height } = rootBounds || {};
      
      height && setWinHeight(height + 426);
      setFixPosition(scrollPosition);
      setFixDirection(scrollDir);
    },
    onLeave: ({ entry }) => {
      // Triggered when the target leaves the viewport

      setWinHeight(0);
      setFixPosition(0);
    },
  });

  const throttleFunc = throttle(100, false, () => {
    const coef = ((winHeight - Math.abs(scrollPosition - fixScrollPosition)) / winHeight);
    const plusMinus = fixScrollDirection === 'down' ? 1 : -1 ;
    topPosLeft = plusMinus * 48 * coef - plusMinus * 24;
    topPosRight = -1 * plusMinus * 48 * coef + plusMinus * 24;

    topPosCoeff = 30 + 50 * (plusMinus === -1 ? coef : 1 - coef);
    btmPosCoeff = 180 + 50 * (plusMinus === -1 ? 1 - coef : coef);
  });
  if (winHeight !== 0) {
    throttleFunc();
  }
  */

  const props1: MarqueeProps = {
    speed: 120,
    direction: "left",
    gradient: false,
  };

  const props2: MarqueeProps = {
    speed: 120,
    direction: "right",
    gradient: false,
  };

  return (
    <div
      className="
        relative
        max-w-full
        overflow-hidden
        lg:overflow-hidden
        h-auto
        lg:h-426
        transform
        translate-x-0
        lg:mt-20
        mb-10
        lg:mb-0
      "
    >
      <Marquee
        className="relative z-10 mt-5 lg:mt-16 transform -rotate-6 h-32"
        {...props1}
      >
        <h2 className="text-5.5xl lg:text-8.5xl font-extrabold text-dkGray">Из лаборатории или из природы&nbsp;</h2>
        <h2 className="text-5.5xl lg:text-8.5xl font-extrabold text-dkGray">Из лаборатории или из природы&nbsp;</h2>
        <h2 className="text-5.5xl lg:text-8.5xl font-extrabold text-dkGray">Из лаборатории или из природы&nbsp;</h2>
      </Marquee>
      <div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center z-10 text-white">
        <div className="levitate-max">
          <img
            src={covidModel}
            width={isDesktopOrLaptop ? "438" : "268"}
            height={isDesktopOrLaptop ? "373" : "231"}
            alt=""
          />
        </div>
      </div>
      <Marquee
        className="relative z-30 -mt-6 lg:mt-6 transform -rotate-6 h-32"
        {...props2}
      >
        <h2 className="text-5.5xl lg:text-8.5xl font-extrabold text-white">Из лаборатории или из природы&nbsp;</h2>
        <h2 className="text-5.5xl lg:text-8.5xl font-extrabold text-white">Из лаборатории или из природы&nbsp;</h2>
        <h2 className="text-5.5xl lg:text-8.5xl font-extrabold text-white">Из лаборатории или из природы&nbsp;</h2>
      </Marquee>
      {/*
      <div
        ref={textFrst}
        className="transition duration-100 ease-out max-w-full justify-center items-center"
        style={{
          transform: `translate3d(${topPosLeft}em, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-6deg) skew(0deg, 0deg)`,
          willChange: 'transform',
          transformStyle: 'preserve-3d',
          position: 'absolute',
          display: 'flex',
          left: '0',
          top: `${topPosCoeff}px`,
          whiteSpace: 'nowrap',
          zIndex: 1,
        }}
      >
        <h2 className="text-8.5xl font-extrabold text-dkGray">Из лаборатории или из природы&nbsp;</h2>
        <h2 className="text-8.5xl font-extrabold text-dkGray">Из лаборатории или из природы&nbsp;</h2>
        <h2 className="text-8.5xl font-extrabold text-dkGray">Из лаборатории или из природы&nbsp;</h2>
      </div>
      <div
        ref={textSecond}
        className="transition duration-100 ease-out max-w-full justify-center items-center"
        style={{
          transform: `translate3d(${topPosRight}em, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-6deg) skew(0deg, 0deg)`,
          willChange: 'transform',
          transformStyle: 'preserve-3d',
          position: 'absolute',
          display: 'flex',
          left: '0',
          top: `${btmPosCoeff}px`,
          whiteSpace: 'nowrap',
          zIndex: 20,
        }}
      >
        <h2 className="text-8.5xl font-extrabold text-white">Из лаборатории или из природы&nbsp;</h2>
        <h2 className="text-8.5xl font-extrabold text-white">Из лаборатории или из природы&nbsp;</h2>
        <h2 className="text-8.5xl font-extrabold text-white">Из лаборатории или из природы&nbsp;</h2>
      </div>
      */}
    </div>
  );
}